<template>
  <div id="thank-you">
    <SfCallToAction
      v-e2e="'thank-you-banner'"
      class="banner"
      :title="$t('Thank_You_Order')"
      style="background-color:#F2F1F6;background-size: contain;background-position: right;background-repeat:no-repeat !important;"
    >
      <template #description>
        <div class="banner__order-number">
          <div >
            <span>{{ $t('Thank_You_Order_sub') }}</span>
            <div style="margin-top: var(--spacer-xs)" v-if="social && social.length">
              <SfProperty
                  class="sf-property--full-width sf-property--large summary__property-total" >
                <template #name>
                  <div style="line-height:32px;">{{ $t('thankyou_concat') }} : </div>
                </template>
                <template #value>
                  <div style="display: flex;flex-wrap: wrap;flex: 1;">
                    <SfImage class="footer__social-image" v-for="(item, key) in social" v-if="item.type == '1'" :key="key"
                    :src="addBasePath('/icons/' + item.iso + '.svg')" :alt="item.iso" :width="32" :height="32"
                    @click="openLink(item.link)" style="margin:0;margin-left:0.5rem;" />
                  </div>
                </template>
               </SfProperty>
            </div>
            <!-- <span>{{ $t('Order No.') }}</span>
            <strong>{{ orderNumber }}</strong> -->
            <!-- display: grid;grid-template-columns: repeat(2, 1fr);gap:0.5rem; -->
            <div style="margin-top: 2rem;">
                <div v-if="preOrderDetails" >
                  <SfProperty
                  v-for="orderId1 in preOrderDetails.order_ids" :key="orderId1"
                  :name="$t('Order_No')"
                  :value="orderId1"
                  class="sf-property--full-width sf-property--large summary__property-total" ></SfProperty>
                </div>
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.amount"
                  :name="$t('payPrice')"
                  :value="$n(Number(preOrderDetails.amount), {
                    style: 'currency',
                    currency: preOrderDetails.currency,
                  })"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address"
                  :name="$t('order_shopping_firstname')"
                  :value="$t(preOrderDetails.address.country)+''"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address"
                  :name="$t('Country')"
                  :value="preOrderDetails.address.first_name+''+preOrderDetails.address.last_name"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.state"
                  :name="$t('MyAccount_MyShippingDetails_State')"
                  :value="(preOrderDetails.address.state)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.city"
                  :name="$t('MyAccount_MyShippingDetails_City')"
                  :value="(preOrderDetails.address.city)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.apartment"
                  :name="$t('MyAccount_MyShippingDetails_HouseNumber')"
                  :value="(preOrderDetails.address.apartment)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.street"
                  :name="$t('MyAccount_MyShippingDetails_Street')"
                  :value="(preOrderDetails.address.street)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.zip_code"
                  :name="$t('MyAccount_MyShippingDetails_Zip')"
                  :value="(preOrderDetails.address.zip_code)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
                <SfProperty
                  v-if="preOrderDetails && preOrderDetails.address && preOrderDetails.address.phone"
                  :name="$t('MyAccount_MyShippingDetails_Phone')"
                  :value="(preOrderDetails.address.phone)"
                  class="sf-property--full-width sf-property--large summary__property-total"
                />
            </div>
          </div>
        </div>
      </template>
    </SfCallToAction>
    <SfButton
      class="back-button color-secondary button-size"
      @click="goOrderList"
      >{{ $t('go_buy_goods') }}
    </SfButton>
  </div>
</template>

<script>
import { SfHeading, SfButton, SfCallToAction, SfProperty, SfImage } from '@storefront-ui/vue';
import { ref, useRoute, onMounted, computed } from '@nuxtjs/composition-api';
import { addBasePath } from '@vue-storefront/core';
import { useOrderCheckoutDetails, useOrderDetail } from '@bee-hole/coms';
export default {
  components: {
    SfHeading,
    SfButton,
    SfCallToAction,
    SfProperty,
    SfImage
  },
  setup(props, context) {
    const { getDetails, result } = useOrderCheckoutDetails();
    const { orderOne } = useOrderDetail();
    const route = useRoute();
    const companyDetails = ref({
      name: 'Divante Headquarter',
      street: 'St. Dmowskiego 17, 53-534',
      city: 'Wroclaw, Poland',
      email: 'demo@vuestorefront.io'
    });
    const orderNumber = ref(route.value.query.orderNumber);
    const goContactUs = () => {
      const transformedPath = '/Contactus';
      context.root.$router.push(context.root.localePath(transformedPath));
    };
    const goOrderList = () => {
      const transformedPath = '/';
      context.root.$router.push(context.root.localePath(transformedPath));
    };
    const googleEvent = (orderOneData) => {
      context.root.$gtm.push({
        event: "purchase",
        ecommerce: null
      });
      const orderDataGtm = {
        'event': 'purchase',
        'ecommerce': {
          'transaction_id': orderOneData.data?.orderId,
          'value': orderOneData.data?.totalCount,
          'currency': orderOneData.data?.currency,
          "tax": orderOneData.data?.taxFee,
          "shipping": orderOneData.data?.postFee,
          "items": []
        }
      };
      orderDataGtm.ecommerce.items = orderOneData.data?.orderItem.map((item) => {
        return {
          'item_id': item.goodId,
          'item_name': item.title,
          'discount': item.discount,
          'item_variant': item.skuProp,
          'price': item.price,
          'quantity': item.num,

          // 'affiliation': "Google Merchandise Store",
          'coupon': "SUMMER_FUN",
          'index': 0,
          'item_brand': "Google",
          'item_category': "Apparel",
          'item_category2': "Adult",
          'item_category3': "Shirts",
          'item_category4': "Crew",
          'item_category5': "Short sleeve",
          'item_list_id': "related_products",
          'item_list_name': "Related Products"
        };
      });
      context.root.$gtm.push(
        orderDataGtm
      );
    };
    const social = computed(() => {
      const list = [];
      let list1 = [];
      if (!context?.root?.$options?.$storeConfig?.mall_home_type || context?.root?.$options?.$storeConfig?.mall_home_type === 'default') {
        list1 = context?.root?.$options?.$mallConfig?.mall_zx_home?.Social;
      } else {
        list1 = context?.root?.$options?.$mallConfig?.mall_home_artice?.Sociall;
      }
      list1?.map(item => {
        if (item.type === '1') list.push(item);
      });
      return list;
    });
    const openLink = (link) => {
      if (link) {
        window.open(link, "_blank");
      }
    };
    onMounted(async () => {
      try {
        const query = {
          prepay_id: orderNumber.value
        };
        if (route.value.query.is_manual_payment) {
          query.is_manual_payment = true;
        }
        await getDetails(query);
      } catch (e) {
        console.log('error', e);
      }
      if (result.value?.order_ids) {
        result.value.order_ids.forEach(async (orderId) => {
          const orderOneData = await orderOne({order_id: orderId});
          if (orderOneData && orderOneData.code === 0) {
            googleEvent(orderOneData);
          }
        });
      }
      // //推送订单金额
      // context.root.$gtm.push(
      //   {
      //     'event':'purchase',
      //     'transaction_id': orderNumber.value,
      //     'value': result.value?.amount,
      //     'currency': result.value?.currency,
      //   }
      // );
    });
    return {
      addBasePath,
      companyDetails,
      goOrderList,
      orderNumber,
      goContactUs,
      preOrderDetails: result,
      social,
      openLink
    };
  }
};
</script>
<style lang="scss" scoped>
#thank-you {
  .sf-property--full-width{
    margin-bottom: 0.5rem;
  }
  box-sizing: border-box;

  @include for-desktop {
    max-width: 1272px;
    padding: 0 0;
    margin: 0 auto;
  }
  @include for-mobile{
    padding: 0 var(--spacer-sm);
  }
}

.heading {
  --heading-padding: var(--spacer-base) 0;

  @include for-desktop {
    --heading-padding: var(--spacer-sm) 0 var(--spacer-xs) 0;
  }
}

.paragraph {
  margin: 0;
  color: var(--c-link);
  font: var(--font-weight--normal) var(--font-size--base) / 1.6
    var(--font-family--primary);

  @include for-desktop {
    font-weight: var(--font-weight--light);
    font-size: var(--font-size--sm);
    margin-bottom: var(--spacer-lg);
  }
}

.banner {
  --call-to-action-color: var(--c-text);
  --call-to-action-title-font-size: var(--h2-font-size);
  --call-to-action-title-font-weight: var(--font-weight--semibold);
  --call-to-action-text-container-width: 50%;
  @include for-mobile{
    --call-to-action-text-container-width: 100%;
  }
  @include for-desktop {
    margin: 0 0 var(--spacer-2xl) 0;
  }

  &__order-number {
    display: flex;
    flex-direction: column;
    font: var(--font-weight--light) var(--font-size--sm) / 1.4
      var(--font-family--primary);

    @include for-desktop {
      flex-direction: row;
      font-size: var(--font-size--normal);
    }
  }
}

.section {
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @include for-desktop {
    flex-direction: row;
    padding: 0;
    background: var(--c-light);
  }
}

.order {
  background: var(--c-light);
  padding-bottom: var(--spacer-sm);

  @include for-desktop {
    width: 100%;
    padding: var(--spacer-xl) var(--spacer-xl) var(--spacer-2xl)
      var(--spacer-2xl);
  }

  &__heading {
    --heading-title-font-weight: var(--font-weight--bold);

    @include for-desktop {
      --heading-title-color: var(--c-link);
      --heading-title-font-weight: var(--font-weight--swemibold);
    }
  }

  &__heading,
  &__paragraph,
  &__contact {
    @include for-mobile {
      margin: 0;
      padding-left: var(--spacer-sm);
      padding-right: var(--spacer-sm);
    }
  }

  &__contact {
    padding-bottom: var(--spacer-base);
    --heading-title-font-size: var(--font-size--lg);
    --heading-title-font-weight: var(--font-weight--medium);

    @include for-desktop {
      --heading-title-font-size: var(--font-size--base);
      --heading-title-font-weight: var(--font-weight--normal);
      padding: 0 var(--spacer-sm);
      border: 2px solid var(--c-white);
      border-width: 2px 0 2px 0;
    }
  }

  &__notifications-button {
    --button-width: calc(100% - var(--spacer-lg));
    margin: 0 auto;

    @include for-desktop {
      margin: var(--spacer-xl) 0 0 0;
    }
  }
}

.contact {
  color: var(--c-dark-variant);
  font: var(--font-weight--light) var(--font-size--base) / 1.6
    var(--font-family--secondary);

  @include for-desktop {
    font-weight: var(--font-weight--normal);
    font-size: var(--font-size--sm);
  }

  &__name,
  &__street,
  &__city {
    margin: 0;
  }

  &__email {
    margin: var(--spacer-sm) 0 0 0;

    @include for-desktop {
      margin-bottom: var(--spacer-sm);
    }
  }

  &__name,
  &__street,
  &__city,
  &__email {
    font-size: var(--font-size--sm);
  }
}

.additional-info {
  --heading-title-font-weight: var(--font-weight--bold);
  padding: 0 var(--spacer-sm);

  @include for-desktop {
    --heading-title-color: var(--c-link);
    --heading-title-font-weight: var(--font-weight--semibold);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--spacer-xl) var(--spacer-xl) var(--spacer-2xl)
      var(--spacer-2xl);
  }
}

.feedback-button {
  margin: var(--spacer-xl) 0 var(--spacer-sm) 0;

  @include for-desktop {
    margin: var(--spacer-base) 0 0 0;
  }
}

.back-button {
  --button-width: calc(100% - var(--spacer-lg));
  margin: 0 auto var(--spacer-sm) auto;

  @include for-desktop {
    margin: var(--spacer-xl) auto;
  }
  @include for-mobile{
    margin:0;
    margin-top: var(--spacer-sm);
    width: 100%;
  }
}
.order__paragraph{
   @include for-desktop {
    --button-width: 25rem;
  }
  width: var(--button-width);
}
.button-size {
  @include for-desktop {
    --button-width: 25rem;
  }
}
</style>
